import React from 'react';
import { AiMagic } from '@fabric-ui/icons';
import { dotStyle, flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import { format, isToday, isYesterday, parseISO } from 'date-fns';

export const formatRelativeTime = (dateInput: string | Date | number): string => {
  // Using parseISO for strings is more reliable for ISO 8601 format.
  // Otherwise, create a new Date object.
  const date = typeof dateInput === 'string' ? parseISO(dateInput) : new Date(dateInput);

  if (isToday(date)) {
    // The single quotes around 'Today,' tell date-fns to treat it as a literal string.
    // 'p' is the token for localized time with AM/PM, like "4:30 PM".
    return format(date, "'Today,' p");
  }

  if (isYesterday(date)) {
    return format(date, "'Yesterday,' p");
  }

  // For any other day, format as "Month Day, Time"
  // 'MMM' -> Oct
  // 'd'   -> 26
  // 'p'   -> 2:20 PM
  return format(date, 'MMM d, p');
};

export const getAiMagicIcon = (size: number, iconStyle?: object) => (
  <Box sx={theme => ({ ...flex.center, ...dotStyle(theme.palette.colors.primary[150], size) })}>
    <AiMagic style={iconStyle} />
  </Box>
);
